// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uni_modal {
  width: 82vw;
}
@media screen and (min-width: 1024px) and (max-width: 1439px) {
  .uni_modal {
    width: 90vw;
  }
}

.w {
  width: 100%;
  display: flex;
  flex-direction: row;
}

.part_width {
  width: 50%;
  border-right: 1px solid #a3b9d9;
  margin-right: 10px;
  padding-right: 10px;
}

.temp {
  width: 15em;
  height: 15em;
  background-color: #fff;
  position: relative;
}
.temp.toPrint {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.temp.toPrint .qrCodeImg {
  opacity: 1;
}

.img_zone {
  width: 10em;
  height: 10em;
  background-color: #fff;
}

.qr {
  display: flex;
  flex-direction: row;
  align-items: end;
  gap: 10px;
  margin-right: 10px;
}

.qr_whole {
  width: 55%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}

.lower_selects {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.6em;
  margin-bottom: 12px;
  margin-top: 12px;
}

.lower_selects_item {
  flex-basis: calc(50% - 10px);
}

.guide_size {
  width: 50%;
  height: 20em;
}

.block_opacity {
  opacity: 50%;
}

.image_wrap {
  display: flex;
  flex-direction: row-reverse;
  align-items: start;
  gap: 2em;
  background-color: #fff;
}

.pos {
  position: absolute;
  right: 18em;
}`, "",{"version":3,"sources":["webpack://./src/Components/SamplesList/SampleUniModal/uniModal.scss"],"names":[],"mappings":"AAAA;EAEE,WAAA;AAAF;AACE;EAHF;IAII,WAAA;EAEF;AACF;;AACA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AAEF;;AAAA;EACE,UAAA;EACA,+BAAA;EACA,kBAAA;EAGA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AACF;AAAE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;AAEJ;AADI;EAEE,UAAA;AAEN;;AAGA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,SAAA;EACA,kBAAA;AAAF;;AAIA;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EAEE,4BAAA;AAFF;;AAKA;EACE,UAAA;EACA,YAAA;AAFF;;AAKA;EACE,YAAA;AAFF;;AAKA;EACE,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,WAAA;AAFF","sourcesContent":[".uni_modal {\n  // height: 80vh;\n  width: 82vw;\n  @media screen and (min-width: 1024px) and (max-width: 1439px) {\n    width: 90vw;\n  }\n}\n\n.w {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n}\n.part_width {\n  width: 50%;\n  border-right: 1px solid #a3b9d9;\n  margin-right: 10px;\n  // margin-right: auto;\n\n  padding-right: 10px;\n}\n\n.temp {\n  width: 15em;\n  height: 15em;\n  background-color: #fff;\n  position: relative;\n  &.toPrint {\n    position: absolute;\n    left: 0;\n    top: 0;\n    z-index: -1;\n    .qrCodeImg {\n      // filter: blur(0px);\n      opacity: 1;\n    }\n  }\n}\n\n.img_zone {\n  width: 10em;\n  height: 10em;\n  background-color: #fff;\n}\n\n.qr {\n  display: flex;\n  flex-direction: row;\n  align-items: end;\n  gap: 10px;\n  margin-right: 10px;\n  // margin-right: auto;\n}\n\n.qr_whole {\n  width: 55%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: end;\n}\n\n.lower_selects {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 0.6em;\n  margin-bottom: 12px;\n  margin-top: 12px;\n}\n\n.lower_selects_item {\n  // padding: 10px;\n  flex-basis: calc(50% - 10px);\n}\n\n.guide_size {\n  width: 50%;\n  height: 20em;\n}\n\n.block_opacity {\n  opacity: 50%;\n}\n\n.image_wrap {\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: start;\n  gap: 2em;\n  background-color: #fff;\n}\n\n.pos {\n  position: absolute;\n  right: 18em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
